const LocationIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#E93864" className="bi bi-geo-alt-fill" viewBox="0 0 16 16" style={{ margin: "5px 5px 5px 0"}}>
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
            </svg>
        </>
    );
}

export default LocationIcon;